export const geneticsModuleOverview = [
  {
    id: "basics",
    title: "The Basics",
    description: "Core inheritance and gene principles.",
    icon: "🧬",
    gradient: "from-sky-100 via-blue-50 to-indigo-100 border-blue-300",
  },
  {
    id: "methods",
    title: "Genetics Methods",
    description: "Common lab and diagnostic techniques.",
    icon: "🧪",
    gradient: "from-emerald-100 via-teal-50 to-cyan-100 border-teal-300",
  },
  {
    id: "chromosome-defects",
    title: "Chromosomal Defects: Part 1",
    description: "Aneuploidy and structural changes.",
    icon: "🧷",
    gradient: "from-amber-100 via-yellow-50 to-orange-100 border-amber-300",
  },
  {
    id: "chromosome-defects-2",
    title: "Chromosomal Defects: Part 2",
    description: "Coming soon.",
    icon: "🧷",
    gradient: "from-amber-100 via-yellow-50 to-orange-100 border-amber-300",
  },
  {
    id: "chromosome-defects-3",
    title: "Chromosomal Defects: Part 3",
    description: "Coming soon.",
    icon: "🧷",
    gradient: "from-amber-100 via-yellow-50 to-orange-100 border-amber-300",
  },
  {
    id: "biochemical-disorders",
    title: "Biochemical Disorders",
    description: "Inborn errors and metabolism.",
    icon: "⚗️",
    gradient: "from-pink-100 via-rose-50 to-fuchsia-100 border-pink-300",
  },
  {
    id: "repeat-disorders",
    title: "Repeat Disorders",
    description: "Trinucleotide repeat conditions.",
    icon: "🔁",
    gradient: "from-violet-100 via-purple-50 to-indigo-100 border-violet-300",
  },
];
